// extracted by mini-css-extract-plugin
export var logo = "_7m-2";
export var logoWrapper = "_7m-1";
export var strip = "_7m-0";